
define('text!templates/modules/template/edit/template.html',[],function () { return '<div class="template-module">\n    <div class="template-header"></div>\n    <div class="template-content page-content"></div>\n</div>\n';});

